<template>
  <div class="container-fluid">
    <route-header>
      <h3>{{ $t('labels.nav.dashboard') }}</h3>
    </route-header>
    <div class="row">
      <div class="col-12">
        <budget-balances />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <fund-balances />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      email: ''
    }
  },
  created () {
    this.$store.dispatch('showUser')
  }
}
</script>
